<template>
  <div class="rightnews">

    <ul class="news-list">

      <div v-for="(item,index) in newsList" :key="item.id">
        <li>
          <a href="javascript:;" @click="goArticle(item.id)">{{item.title}}</a>
          <span class="time">{{item.fbsjShort}}</span>
        </li>
        <li class="line" v-if="index>0 && (index+1)%5==0"></li>
      </div>
    </ul>

    <div class="page">

      <span class="text" v-if="(page.count%page.pageSize) >0">共{{page.count}}条{{parseFloat((page.count/page.pageSize)+1).toFixed(0)}}页</span>
      <span class="text" v-if="(page.count%page.pageSize) ==0">共{{page.count}}条{{parseFloat((page.count/page.pageSize)).toFixed(0)}}页</span>
      <span class="text">当前第<b>{{page.pageNo}}</b>页</span>
      <a href="javascript:;" class="item" @click="goPage(page.pageNo-1,15)">上一页</a>
      <a href="javascript:;" class="item" v-if="(page.count%page.pageSize) >0 && parseFloat((page.count/page.pageSize)).toFixed(0) >= page.pageNo " @click="goPage(page.pageNo+1,15)">下一页</a>
	  <a href="javascript:;" class="item" v-if="(page.count%page.pageSize) ==0 && parseFloat((page.count/page.pageSize)).toFixed(0) >= page.pageNo " @click="goPage(page.pageNo,15)">下一页</a>
      
	  <a href="javascript:;" class="item" v-if="(page.count%page.pageSize) >0" @click="goPage(parseFloat((page.count/page.pageSize)+1).toFixed(0),15)">末页</a>
      <a href="javascript:;" class="item" v-if="(page.count%page.pageSize) ==0" @click="goPage(parseFloat((page.count/page.pageSize)).toFixed(0),15)">末页</a>
    </div>


  </div>
</template>

<script>

  export default {
    inject: ["reload"],
    name: 'rightnews',
    components: {},
    pageSize:15,
    pageNo : 1,
    data() {
      return {
        newsList: [],
        page: {}
      }
    },
    props: {
      menuid: {
        type: String,
        default: '' // 子组件在props中创建一个属性，用以接收父组件传过来的值
      },
      menutext: {
        type: String,
        default: '' // 子组件在props中创建一个属性，用以接收父组件传过来的值
      },
      pageNo: {
        type: String,
        default: '1' // 子组件在props中创建一个属性，用以接收父组件传过来的值
      },
      pageSize: {
        type: String,
        default: '15' // 子组件在props中创建一个属性，用以接收父组件传过来的值
      },

    },
    mounted() {
      //this.findPageList()
    },
    created() {
      this.findPageList()
    },
    methods: {
      goPage(pageNo, pageSize) {
        var that = this;
        var keyword = that.$route.query.keyword;
        if (keyword != '' ){
          keyword = '&keyword='+keyword;
        }
        that.$myHttp.post("findPageList?type=" + that.menuid + "&pageSize=" + pageSize + "&pageNo=" + pageNo +keyword)
          .then(function(data) {
            console.log(data)
            if (data.status == "200") {
              that.newsList = [];
              that.newsList = data.data.page.list;
              that.page = data.data.page;
            } else {
              alert("数据请求错误")
            }

          }).catch(function(error) {
            alert(error)
          })
      },
      goPage1(pageNo, pageSize) {
        var that = this;
        var keyword = that.$route.query.keyword;
        if (keyword != '' ){
          keyword = '&keyword='+keyword;
        }
        that.$myHttp.post("findPageList?type=" + that.menuid + "&pageSize=" + pageSize + "&pageNo=" + pageNo　+　keyword)

          .then(function(data) {

            console.log(data)
            if (data.status == "200") {
              that.newsList = [];
              that.newsList = data.data.page.list;
              that.page = data.data.page;
            } else {
              alert("数据请求错误")
            }

          }).catch(function(error) {
            alert(error)
          })
      },
      goArticle(articleId) {
        let {
          href
        } = this.$router.resolve({
          path: "/Article", // 这里写的是要跳转的路由地址
          query: {
            articleId: articleId,
            menutext: this.menutext
          } // 这里写的是页面参数
        });

        window.open(href, '_blank');
      },
      findPageList() {
        var that = this;
        var keyword = that.$route.query.keyword;
        if (keyword != '' ){
          keyword = '&keyword='+keyword;
        }
        var pageSize = that.$route.query.pageSize;
        var pageNo = that.$route.query.pageNo;
        if (typeof(pageSize) != 'undefined') {
          that.pageSize = pageSize;
          that.pageNo = pageNo;
        }

        //that.$myHttp.post("findPageList?type="+ that.menuid +"&pageSize=15")
        //alert("findPageList?type="+ that.menuid +"&pageSize="+that.pageSize+"&pageNo="+that.pageNo)
        that.$myHttp.post("findPageList?type=" + that.menuid + "&pageSize=" + that.pageSize + "&pageNo=" + that.pageNo+keyword)
          .then(function(data) {
            console.log(data)
            if (data.status == "200") {
              that.newsList = [];
              that.newsList = data.data.page.list;
              that.page = data.data.page;
            } else {
              alert("数据请求错误")
            }

          }).catch(function(error) {
            alert(error)
          })


      }
    }
  };
</script>

<style scoped>
  .rightnews {
    width: 100%;
  }

  .title {
    height: 36px;
    line-height: 36px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #6EAA24;
  }

  .title .box-name {
    font-size: 14px;
    color: #fff;
    background: #6eaa24;
    font-weight: bold;
    padding: 0 10px;
  }

  .title .more {
    color: #515151;
    font-size: 12px;
    padding-right: 15px;
    background: url(../../../assets/img/1.png) no-repeat right center;
  }

  .news-list {
    padding-top: 10px;
  }

  .news-list li {
    display: flex;
    justify-content: space-between;
  }

  .news-list .line {
    background: #cdcdcd;
    display: block;
    width: 100%;
    height: 1px;
    margin: 10px 0;
  }

  .news-list li a {
    font-size:15px;/*14px*/
    line-height: 31px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333;
    padding-left: 10px;
    width: 80%;
    background: url(/static/img/dot.jpg) left center no-repeat;
  }

  .news-list li a:hover {
    color: #6EAA24;
  }

  .news-list li .time {
    font-size: 14px;
    line-height: 31px;
    color: #888;
  }

  .page {
    margin: 30px 0;
    display: flex;
    justify-content: center;
  }

  .page .text {
    margin: 0 10px;
  }

  .page .item {
    margin: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/front/components/newslist.vue